import PropTypes from 'prop-types';
import { useMemo, useState } from 'react';

function SafeShowMoreText({
  children,
  lines,
  more,
  less,
  className,
  anchorClass,
  expanded,
  truncatedEndingComponent,
}) {
  const [isExpanded, setIsExpanded] = useState(Boolean(expanded));
  const text = useMemo(() => {
    if (children === null || children === undefined) return '';
    return Array.isArray(children) ? children.join('') : String(children);
  }, [children]);

  const maxLength = Math.max(Number(lines || 3) * 90, 120);
  const shouldTruncate = text.length > maxLength;
  const visibleText = !shouldTruncate || isExpanded ? text : text.slice(0, maxLength).trimEnd();

  return (
    <span className={className}>
      <span style={{ whiteSpace: 'pre-line' }}>
        {visibleText}
        {shouldTruncate && !isExpanded ? truncatedEndingComponent : ''}
      </span>
      {shouldTruncate && (
        <span
          className={anchorClass}
          onClick={() => setIsExpanded((value) => !value)}
          style={{ marginLeft: 4 }}
        >
          {isExpanded ? less : more}
        </span>
      )}
    </span>
  );
}

SafeShowMoreText.propTypes = {
  children: PropTypes.node,
  lines: PropTypes.number,
  more: PropTypes.node,
  less: PropTypes.node,
  className: PropTypes.string,
  anchorClass: PropTypes.string,
  expanded: PropTypes.bool,
  truncatedEndingComponent: PropTypes.node,
};

SafeShowMoreText.defaultProps = {
  children: '',
  lines: 3,
  more: 'Xem thêm',
  less: 'Thu gọn',
  className: '',
  anchorClass: '',
  expanded: false,
  truncatedEndingComponent: '... ',
};

export { SafeShowMoreText as ShowMoreText };
export default SafeShowMoreText;
